import { useEffect, useState } from "react";
import { postAccount } from "./accountApi";
import useCurrentUser from "./useCurrentUser";

// Whether the logged in user's profile says they're looking to rent (tuser.profile usertype),
// to put the renter's report first. False when logged out, or until the profile has been read.
// Read once per user and kept for the page's life, so menus that mount on each open don't ask again.

// {email, promise, rent}: the last user asked about
let cached = null;

const ask = (email) => {
    if (cached && cached.email === email) return cached;
    const entry = {email, rent:null};
    entry.promise = postAccount('/getprofile', {})
        .then((r) => { entry.rent = !!(r && r.profile && r.profile.usertype === 'rent'); return entry.rent; })
        .catch(() => { if (cached === entry) cached = null; return false; });
    cached = entry;
    return entry;
};

const useWantsRent = () => {
    const user = useCurrentUser();
    const email = user && user.signedin ? user.email : null;
    const [rent, setRent] = useState(() => !!(email && cached && cached.email === email && cached.rent));
    useEffect(() => {
        if (!email) { setRent(false); return undefined; }
        let stopped = false;
        const entry = ask(email);
        if (entry.rent !== null) setRent(entry.rent);
        else entry.promise.then((r) => { if (!stopped) setRent(r); });
        return () => { stopped = true; };
    }, [email]);
    return rent;
};

// The profile was saved: ask again next time
export const wantsRentChanged = () => { cached = null; };

export default useWantsRent;
